export default __webpack_public_path__ + "static/media/gallery-wip-grenade cap_07.ddbebf51.jpg";